import styled from "styled-components";
import {Button, Input, Alert, List} from "@chakra-ui/react";
import {FaSearch} from "react-icons/fa";
import {Field} from "../../components/ui/field";
import {responsive} from "../../media-quries";
import {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router";
import {Container, Link} from "./address-search";
import {useUpdateQueryParam} from "../../utils/navigation";

const Id = styled(Field)`
  flex-basis: calc(50% - 8px);

  ${responsive.sm`
  flex-basis: 100%;
  `}
`;

const Szukaj = styled(Button)`
  margin-top: 24px;
  flex: 1;
`;

function IdSearch({ searching }) {
    const [parcelId, setParcelId] = useState(null);
    const navigate = useNavigate();
    const updateQueryParams = useUpdateQueryParam();
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    useEffect(() => {
        if (id) {
            setParcelId(id)
        }
    }, [id])

    return <Container>
        <Id label="Identyfikator działki">
            <Input value={parcelId} onChange={(e) => setParcelId(e.target.value)} placeholder="Podaj identyfikator działki" />
        </Id>
        <Szukaj variant="solid"
                disabled={!parcelId || searching}
                onClick={() => {
                    let params = `searchBy=id&id=${parcelId}`;

                    navigate(`/szukaj?${params}`);
                }}>
            <FaSearch /> Szukaj księgi wieczyste
        </Szukaj>
        <Alert.Root colorPalette="accent">
            <Alert.Indicator />
            <Alert.Content>
                <Alert.Title>Jak szukać po identyfikatorze działki:</Alert.Title>
                <Alert.Description>
                    <List.Root>
                        <List.Item>Identyfikator działki ma format WWPPGG_R.OOOO.NDZ, gdzie każda część oznacza kod województwa, powiatu, gminy, obrębu i numer działki, np. 306401_1.0051.70, 306401_1.0051.70/2</List.Item>
                        <List.Item>Dodatkowo, w identyfikatorze może występować opcjonalnie numer arkusza mapy w formacie AR_XX np. 306401_1.0051.AR_17.73/1</List.Item>
                        <List.Item>Jeśli dla wskazanych kryteriów nie udało Ci się znaleść szukanej księgi spróbuj wyszukiwania{' '}
                            <Link onClick={() => updateQueryParams('searchBy', 'address')}>
                                po adresie
                            </Link>{' '}
                            lub po{' '}
                            <Link onClick={() => updateQueryParams('searchBy', 'number')}>
                                numerze działki
                            </Link>
                        </List.Item>
                    </List.Root>
                </Alert.Description>
            </Alert.Content>
        </Alert.Root>
    </Container>
}

export default IdSearch;
